module.exports = ".loader-hidden {\r\n    visibility: hidden;\r\n}\r\n.loader-overlay {\r\n    position: absolute;\r\n    width:100%;\r\n    top:0;\r\n    left: 0;\r\n    opacity: 1;\r\n    z-index: 500000;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/home-page/loader/loader.component.css
// module id = ./src/app/home-page/loader/loader.component.css
// module chunks = main